// document.addEventListener("DOMContentLoaded", function() {
//   const accordionContainer = document.querySelector('.js-accordion');
//   const contentContainer = document.querySelector('.product-single__content-text');

//   if (!accordionContainer || !contentContainer) return;

//   const headers = Array.from(contentContainer.querySelectorAll('h6'));

//   // COMMON DESCRIPTION (everything above first H6)
//   if (headers.length > 0) {
//     let descriptionContent = '';
//     let sibling = contentContainer.firstElementChild;

//     while (sibling && sibling !== headers[0]) {
//       descriptionContent += sibling.outerHTML;
//       sibling.style.display = 'none';
//       sibling = sibling.nextElementSibling;
//     }

//     const descriptionWrapper = document.createElement('div');
//     descriptionWrapper.className = 'product-single__accordion__section active'; // wrapper div

//     const descriptionTitle = document.createElement('div');
//     descriptionTitle.className = 'product-single__accordion__title';
//     descriptionTitle.innerHTML = `
//       <h4 class="product-single__accordion__title-text">Description</h4>
//       <span class="icon icon--theme icon--plus">
//         <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
//           <path d="M24 4L24 44M4 24.0024H44" vector-effect="non-scaling-stroke"></path>
//         </svg>
//       </span>
//     `;

//     const descriptionItem = document.createElement('div');
//     descriptionItem.className = 'product-single__accordion__item';
//     descriptionItem.innerHTML = `<div class="product-single__accordion__item-wrap rte">${descriptionContent}</div>`;

//     descriptionWrapper.append(descriptionTitle, descriptionItem);
//     accordionContainer.append(descriptionWrapper);
//   }

//   // ACCORDIONS for each H6
//   headers.forEach((h6, i) => {
//     const tabName = h6.textContent.trim();
//     if (!tabName) {
//       h6.style.display = 'none';
//       return;
//     }

//     h6.style.display = 'none';

//     let tabContent = '';
//     let sibling = h6.nextElementSibling;
//     while (sibling && sibling.tagName.toLowerCase() !== 'h6') {
//       tabContent += sibling.outerHTML;
//       sibling.style.display = 'none';
//       sibling = sibling.nextElementSibling;
//     }

//     const sectionWrapper = document.createElement('div');
//     sectionWrapper.className = 'product-single__accordion__section'; // wrapper div

//     const sectionTitle = document.createElement('div');
//     sectionTitle.className = 'product-single__accordion__title';
//     sectionTitle.innerHTML = `
//       <h4 class="product-single__accordion__title-text">${tabName}</h4>
//       <span class="icon icon--theme icon--plus">
//         <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
//           <path d="M24 4L24 44M4 24.0024H44" vector-effect="non-scaling-stroke"></path>
//         </svg>
//       </span>
//     `;

//     const sectionItem = document.createElement('div');
//     sectionItem.className = 'product-single__accordion__item hidden';
//     sectionItem.innerHTML = `<div class="product-single__accordion__item-wrap rte">${tabContent}</div>`;

//     sectionWrapper.append(sectionTitle, sectionItem);
//     accordionContainer.append(sectionWrapper);
//   });

//   // Click toggle for accordion items
//   setTimeout(() => {
//     const triggers = document.querySelectorAll('.product-single__accordion__title');
//     triggers.forEach(trigger => {
//       if (trigger.dataset.listenerAdded) return;

//       trigger.addEventListener('click', function() {
//         const sectionWrapper = this.parentElement;
//         const item = sectionWrapper.querySelector('.product-single__accordion__item');
//         const svg = this.querySelector('svg');

//         if (item) {
//           item.classList.toggle('hidden');
//           sectionWrapper.classList.toggle('active');

//           if (svg) {
//             svg.style.transform = sectionWrapper.classList.contains('active') ? 'rotate(45deg)' : 'rotate(0deg)';
//             svg.style.transition = 'transform 0.3s ease';
//           }
//         }
//       });

//       trigger.dataset.listenerAdded = 'true';
//     });
//   }, 1);
// });

document.addEventListener("DOMContentLoaded", function() {
  const accordionContainer = document.querySelector('.js-accordion');
  const contentBlocks = document.querySelectorAll('.product-single__content-text');

  if (!accordionContainer || contentBlocks.length === 0) return;

  // 🧩 Prevent duplication in Firefox or dynamic reloads
  if (accordionContainer.dataset.initialized === 'true') return;
  accordionContainer.dataset.initialized = 'true';

  // Optional: clear previously added accordion sections (safety for dynamic updates)
  accordionContainer.querySelectorAll('.product-single__accordion__section').forEach(section => section.remove());

  let commonDescriptionContent = '';

  // Collect all content above the first H6 across all blocks
  contentBlocks.forEach(block => {
    const headers = block.querySelectorAll('h6');
    let sibling = block.firstElementChild;

    while (sibling && (!headers[0] || sibling !== headers[0])) {
      commonDescriptionContent += sibling.outerHTML;
      sibling.style.display = 'none';
      sibling = sibling.nextElementSibling;
    }
  });

  // Add Description Section (always open)
  if (commonDescriptionContent) {
    const descriptionWrapper = document.createElement('div');
    descriptionWrapper.className = 'product-single__accordion__section active';

    const descriptionTitle = document.createElement('div');
    descriptionTitle.className = 'product-single__accordion__title';
    descriptionTitle.innerHTML = `
      <h4 class="product-single__accordion__title-text">Description</h4>
      <span class="icon icon--theme icon--plus">
        <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
          <path d="M24 4L24 44M4 24.0024H44" vector-effect="non-scaling-stroke"></path>
        </svg>
      </span>
    `;

    const descriptionItem = document.createElement('div');
    descriptionItem.className = 'product-single__accordion__item';
    descriptionItem.innerHTML = `<div class="product-single__accordion__item-wrap rte">${commonDescriptionContent}</div>`;

    descriptionWrapper.append(descriptionTitle, descriptionItem);
    accordionContainer.append(descriptionWrapper);
  }

  // Create accordion sections for each H6 header across blocks
  contentBlocks.forEach(block => {
    const headers = Array.from(block.querySelectorAll('h6'));
    headers.forEach((h6) => {
      const tabName = h6.textContent.trim();
      if (!tabName) {
        h6.style.display = 'none';
        return;
      }

      h6.style.display = 'none';

      let tabContent = '';
      let sibling = h6.nextElementSibling;
      while (sibling && sibling.tagName.toLowerCase() !== 'h6') {
        tabContent += sibling.outerHTML;
        sibling.style.display = 'none';
        sibling = sibling.nextElementSibling;
      }

      const sectionWrapper = document.createElement('div');
      sectionWrapper.className = 'product-single__accordion__section';

      const sectionTitle = document.createElement('div');
      sectionTitle.className = 'product-single__accordion__title';
      sectionTitle.innerHTML = `
        <h4 class="product-single__accordion__title-text">${tabName}</h4>
        <span class="icon icon--theme icon--plus">
          <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <path d="M24 4L24 44M4 24.0024H44" vector-effect="non-scaling-stroke"></path>
          </svg>
        </span>
      `;

      const sectionItem = document.createElement('div');
      sectionItem.className = 'product-single__accordion__item hidden';
      sectionItem.innerHTML = `<div class="product-single__accordion__item-wrap rte">${tabContent}</div>`;

      sectionWrapper.append(sectionTitle, sectionItem);
      accordionContainer.append(sectionWrapper);
    });
  });

  // Setup accordion toggle listeners
  setTimeout(() => {
    const triggers = document.querySelectorAll('.product-single__accordion__title');
    triggers.forEach(trigger => {
      if (trigger.dataset.listenerAdded) return;

      trigger.addEventListener('click', function() {
        const sectionWrapper = this.parentElement;
        const item = sectionWrapper.querySelector('.product-single__accordion__item');
        const svg = this.querySelector('svg');

        if (item) {
          item.classList.toggle('hidden');
          sectionWrapper.classList.toggle('active');

          if (svg) {
            svg.style.transform = sectionWrapper.classList.contains('active') ? 'rotate(45deg)' : 'rotate(0deg)';
            svg.style.transition = 'transform 0.3s ease';
          }
        }
      });

      trigger.dataset.listenerAdded = 'true';
    });
  }, 1);
});








// (function () {
//   // Initialize accordion inside a specific section element
//   function initAccordionForSection(sectionEl) {
//     if (!sectionEl) return;
//     if (sectionEl.dataset.accordionInit === 'true') {
//       console.debug('Accordion: already initialized for', sectionEl.id);
//       return;
//     }

//     const accordionContainer = sectionEl.querySelector('.js-accordion');
//     const contentBlocks = sectionEl.querySelectorAll('.product-single__content-text');

//     if (!accordionContainer || contentBlocks.length === 0) {
//       console.debug('Accordion: no container or content blocks found for', sectionEl.id);
//       return;
//     }

//     // mark as initialized
//     sectionEl.dataset.accordionInit = 'true';

//     // clear any previous content (safe-guard)
//     accordionContainer.innerHTML = '';

//     let commonDescriptionContent = '';

//     // Collect all content above the first H6 across all blocks
//     contentBlocks.forEach(block => {
//       const headers = block.querySelectorAll('h6');
//       let sibling = block.firstElementChild;

//       while (sibling && (!headers[0] || sibling !== headers[0])) {
//         // save original display state so we can restore on unload
//         if (!sibling.dataset.accordionHidden) {
//           sibling.dataset.accordionHidden = 'true';
//           sibling.dataset.accordionOrigDisplay = sibling.style.display || '';
//         }
//         commonDescriptionContent += sibling.outerHTML;
//         sibling.style.display = 'none';
//         sibling = sibling.nextElementSibling;
//       }
//     });

//     // Add Description Section (always open)
//     if (commonDescriptionContent) {
//       const descriptionWrapper = document.createElement('div');
//       descriptionWrapper.className = 'product-single__accordion__section active';

//       const descriptionTitle = document.createElement('div');
//       descriptionTitle.className = 'product-single__accordion__title';
//       descriptionTitle.innerHTML = `
//         <h4 class="product-single__accordion__title-text">Description</h4>
//         <span class="icon icon--theme icon--plus">
//           <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
//             <path d="M24 4L24 44M4 24.0024H44" vector-effect="non-scaling-stroke"></path>
//           </svg>
//         </span>
//       `;

//       const descriptionItem = document.createElement('div');
//       descriptionItem.className = 'product-single__accordion__item';
//       descriptionItem.innerHTML = `<div class="product-single__accordion__item-wrap rte">${commonDescriptionContent}</div>`;

//       descriptionWrapper.append(descriptionTitle, descriptionItem);
//       accordionContainer.append(descriptionWrapper);
//     }

//     // Now create accordions for all H6 elements inside the section
//     contentBlocks.forEach(block => {
//       const headers = Array.from(block.querySelectorAll('h6'));
//       headers.forEach(h6 => {
//         const tabName = h6.textContent.trim();
//         if (!tabName) {
//           h6.style.display = 'none';
//           return;
//         }

//         // hide the h6 (but save state)
//         if (!h6.dataset.accordionHidden) {
//           h6.dataset.accordionHidden = 'true';
//           h6.dataset.accordionOrigDisplay = h6.style.display || '';
//         }
//         h6.style.display = 'none';

//         let tabContent = '';
//         let sibling = h6.nextElementSibling;

//         while (sibling && sibling.tagName.toLowerCase() !== 'h6') {
//           if (!sibling.dataset.accordionHidden) {
//             sibling.dataset.accordionHidden = 'true';
//             sibling.dataset.accordionOrigDisplay = sibling.style.display || '';
//           }
//           tabContent += sibling.outerHTML;
//           sibling.style.display = 'none';
//           sibling = sibling.nextElementSibling;
//         }

//         const sectionWrapper = document.createElement('div');
//         sectionWrapper.className = 'product-single__accordion__section';

//         const sectionTitle = document.createElement('div');
//         sectionTitle.className = 'product-single__accordion__title';
//         sectionTitle.innerHTML = `
//           <h4 class="product-single__accordion__title-text">${escapeHtml(tabName)}</h4>
//           <span class="icon icon--theme icon--plus">
//             <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
//               <path d="M24 4L24 44M4 24.0024H44" vector-effect="non-scaling-stroke"></path>
//             </svg>
//           </span>
//         `;

//         const sectionItem = document.createElement('div');
//         sectionItem.className = 'product-single__accordion__item hidden';
//         sectionItem.innerHTML = `<div class="product-single__accordion__item-wrap rte">${tabContent}</div>`;

//         sectionWrapper.append(sectionTitle, sectionItem);
//         accordionContainer.append(sectionWrapper);
//       });
//     });

//     // Attach click toggles for the created titles (scoped to this accordionContainer)
//     // Use delegated query within container so we don't accidentally double-add listeners on global elements
//     setTimeout(() => {
//       const triggers = accordionContainer.querySelectorAll('.product-single__accordion__title');
//       triggers.forEach(trigger => {
//         if (trigger.dataset.listenerAdded === 'true') return;

//         const clickHandler = function () {
//           const sectionWrapper = this.parentElement;
//           const item = sectionWrapper.querySelector('.product-single__accordion__item');
//           const svg = this.querySelector('svg');

//           if (item) {
//             item.classList.toggle('hidden');
//             sectionWrapper.classList.toggle('active');

//             if (svg) {
//               svg.style.transform = sectionWrapper.classList.contains('active') ? 'rotate(45deg)' : 'rotate(0deg)';
//               svg.style.transition = 'transform 0.3s ease';
//             }
//           }
//         };

//         // store handler reference so (if needed) we can remove later (we don't strictly need it here)
//         trigger.addEventListener('click', clickHandler);
//         trigger.dataset.listenerAdded = 'true';
//       });
//     }, 1);

//     console.debug('Accordion initialized for', sectionEl.id);
//   }

//   // Destroy accordion and restore original DOM inside a section element
//   function destroyAccordionForSection(sectionEl) {
//     if (!sectionEl) return;
//     if (sectionEl.dataset.accordionInit !== 'true') {
//       console.debug('Accordion: nothing to destroy for', sectionEl.id);
//       return;
//     }

//     // restore hidden elements that we previously hid
//     const hiddenNodes = sectionEl.querySelectorAll('[data-accordion-hidden="true"]');
//     hiddenNodes.forEach(node => {
//       const orig = node.dataset.accordionOrigDisplay;
//       // If the element previously had an inline style, restore it; otherwise clear inline style
//       node.style.display = orig || '';
//       delete node.dataset.accordionHidden;
//       delete node.dataset.accordionOrigDisplay;
//     });

//     // remove accordion content
//     const accordionContainer = sectionEl.querySelector('.js-accordion');
//     if (accordionContainer) {
//       accordionContainer.innerHTML = '';
//     }

//     delete sectionEl.dataset.accordionInit;
//     console.debug('Accordion destroyed and DOM restored for', sectionEl.id);
//   }

//   // Helper to escape text used inside innerHTML for the title (prevent accidental HTML injection)
//   function escapeHtml(text) {
//     return text
//       .replace(/&/g, "&amp;")
//       .replace(/</g, "&lt;")
//       .replace(/>/g, "&gt;")
//       .replace(/"/g, "&quot;")
//       .replace(/'/g, "&#039;");
//   }

//   // On initial page load: initialize accordions for all sections that contain .js-accordion
//   document.addEventListener('DOMContentLoaded', function () {
//     const containers = document.querySelectorAll('.js-accordion');
//     containers.forEach(container => {
//       const sectionEl = container.closest('[id^="shopify-section-"]') || container.closest('section') || document.documentElement;
//       if (sectionEl) initAccordionForSection(sectionEl);
//     });
//   });

//   // Shopify Theme Editor: section load/unload
//   document.addEventListener('shopify:section:load', function (event) {
//     // event.target is the root element of the re-rendered section
//     const sectionEl = event.target;
//     try {
//       initAccordionForSection(sectionEl);
//     } catch (err) {
//       console.error('Accordion init error on shopify:section:load', err);
//     }
//   });

//   document.addEventListener('shopify:section:unload', function (event) {
//     const sectionEl = event.target;
//     try {
//       destroyAccordionForSection(sectionEl);
//     } catch (err) {
//       console.error('Accordion destroy error on shopify:section:unload', err);
//     }
//   });

//   // Also expose functions for manual control (useful for debugging from console)
//   window.__ShopifyAccordion = {
//     init: initAccordionForSection,
//     destroy: destroyAccordionForSection
//   };
// })();
